import React, { lazy, Suspense } from "react";
import { Route, useLocation, Routes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import PageLoader from "@/components/PageLoader";
import { roles } from "@/utils/constant";
import HeaderContent from "@/layout/HeaderContent";

const Appraisal = lazy(() =>
  import(/*webpackChunkName:'AppraisalPage'*/ "@/pages/Appraisal")
);

const AppraisalDetails = lazy(() =>
  import(/*webpackChunkName:'AppraisalDetailsPage'*/ "@/pages/AppraisalDetails")
);

const AppraisalStatusMessageForm = lazy(() =>
  import(
    /*webpackChunkName:'CustomerPage'*/ "@/pages/AppraisalStatusMessageForm"
  )
);

const ForgetPassword = lazy(() =>
  import(/*webpackChunkName:'ForgetPasswordPage'*/ "@/pages/ForgetPassword")
);
const ShopAddRequestForm = lazy(() =>
  import(
    /*webpackChunkName:'ShopAddRequestFormPage'*/ "@/pages/ShopAddRequestForm"
  )
);

const NotFound = lazy(() =>
  import(/*webpackChunkName:'NotFoundPage'*/ "@/pages/NotFound")
);

const Reports = lazy(() =>
  import(/*webpackChunkName:'ReportsPage'*/ "@/pages/Reports")
);

const Settings = lazy(() =>
  import(/*webpackChunkName:'SettingsPage'*/ "@/pages/Settings")
);

const Insights = lazy(() =>
  import(/*webpackChunkName:'InsightsPage'*/ "@/pages/Insights")
);

const ShopProfile = lazy(() =>
  import(/*webpackChunkName:'AddShopPage'*/ "@/pages/ShopProfile")
);

const WriterProfile = lazy(() =>
  import(/*webpackChunkName:'WriterProfilePage'*/ "@/pages/WriterProfile")
);

const EditRolePermissionManagement = lazy(() =>
  import(
    /*webpackChunkName:'AddShopPage'*/ "@/pages/EditRolePermissionManagement"
  )
);

const AddInsurance = lazy(() =>
  import(/*webpackChunkName:'AddShopPage'*/ "@/components/AddInsurance")
);

export default function AppRouter() {
  const location = useLocation();

  return (
    <Suspense fallback={<PageLoader />}>
      <HeaderContent />
      <Routes >
        <Route path="/" element={<Appraisal />} />
        <Route path="/appraisal" element={<PrivateRoute rootAccess={true} />}>
          <Route index element={<Appraisal />} />

          <Route
            path="add-request-form"
            element={<PrivateRoute roles={[roles.SHOPOWNER]} />}
          >
            <Route index element={<ShopAddRequestForm />} />
          </Route>

          <Route
            path="edit-request-form"
            element={<PrivateRoute roles={[roles.SHOPOWNER]} />}
          >
            <Route index element={<ShopAddRequestForm />} />
          </Route>

          <Route path="details" element={<AppraisalDetails />} />

          <Route
            path="reupload-request-form"
            element={<PrivateRoute roles={[roles.SHOPOWNER]} />}
          >
            <Route index element={<ShopAddRequestForm />} />
          </Route>

          <Route
            path="rejection-form"
            element={<AppraisalStatusMessageForm />}
          />

          <Route path="cancel-form" element={<AppraisalStatusMessageForm />} />
        </Route>

        <Route path="reports" element={<PrivateRoute roles={[roles.ADMIN]} />}>
          <Route index element={<Reports />} />
        </Route>

        <Route path="settings" element={<PrivateRoute roles={[roles.ADMIN]} />}>
          <Route index element={<Settings />} />

          <Route
            path="add-shop"
            element={<PrivateRoute roles={[roles.ADMIN]} />}
          >
            <Route index element={<ShopProfile title={"Add Shop Profile"} />} />
          </Route>

          <Route
            path="add-staff"
            element={<PrivateRoute roles={[roles.ADMIN]} />}
          >
            <Route
              index
              element={<WriterProfile title={"Add Staff Member"} />}
            />
          </Route>

          <Route
            path="edit-role"
            element={<PrivateRoute roles={[roles.ADMIN]} />}
          >
            <Route
              index
              element={<EditRolePermissionManagement title={"Edit Role"} />}
            />
          </Route>

          <Route
            path="add-insurance"
            element={<PrivateRoute roles={[roles.ADMIN]} />}
          >
            <Route index element={<AddInsurance />} />
          </Route>

          <Route
            path="edit-insurance"
            element={<PrivateRoute roles={[roles.ADMIN]} />}
          >
            <Route index element={<AddInsurance />} />
          </Route>
        </Route>

        <Route path="insights" element={<PrivateRoute roles={[roles.ADMIN]} />}>
          <Route index element={<Insights />} />
        </Route>

        <Route path="*" element={<NotFound />} />

        <Route
          path="shop-profile"
          element={
            <PrivateRoute roles={[roles.APPRAISALWRITER, roles.SHOPOWNER]} />
          }
        >
          <Route index element={<ShopProfile title={"Add Shop Profile"} />} />
        </Route>

        <Route
          path="profile"
          element={
            <PrivateRoute roles={[roles.APPRAISALWRITER, roles.SHOPOWNER]} />
          }
        >
          <Route index element={<WriterProfile title={"Add Staff Member"} />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

{
  /* 
  Old code for role check
  
  <PrivateRoute rootAccess={true} component={Appraisal} path="/appraisal" exact />
          <PrivateRoute roles={[roles.SHOPOWNER]} component={ShopAddRequestForm} path="/appraisal/add-request-form" exact />
          <PrivateRoute roles={[roles.SHOPOWNER]} component={ShopAddRequestForm} path="/appraisal/edit-request-form" exact />
          <PrivateRoute roles={[roles.SHOPOWNER]} component={ShopAddRequestForm} path="/appraisal/reupload-request-form" exact />
          <PrivateRoute rootAccess={true} component={AppraisalDetails} path="/appraisal/details" exact />
          <PrivateRoute roles={[roles.APPRAISALWRITER]} component={AppraisalStatusMessageForm} path="/appraisal/rejection-form" exact />
          <PrivateRoute rootAccess={true} component={AppraisalStatusMessageForm} path="/appraisal/cancel-form" exact /> */
}
